"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const isPhysicalProduct_1 = __importDefault(require("./isPhysicalProduct"));
const getPhProductsQtyAndPrice = (lineItems) => {
    const result = lineItems.reduce((acc, item) => {
        var _a;
        const { isPhProduct, isBasicPhProduct, isPhSubscriptionProduct } = isPhysicalProduct_1.default((_a = item.variant) === null || _a === void 0 ? void 0 : _a.attributes);
        if (!isPhProduct)
            return acc;
        return {
            physicalSubscriptionQty: isPhSubscriptionProduct
                ? acc.physicalSubscriptionQty + 1
                : acc.physicalSubscriptionQty,
            physicalProductsQty: isBasicPhProduct ? acc.physicalProductsQty + 1 : acc.physicalProductsQty,
            price: acc.price + item.totalPrice.centAmount / 100,
        };
    }, {
        physicalSubscriptionQty: 0,
        physicalProductsQty: 0,
        price: 0,
    });
    return {
        physicalProductsQty: result.physicalProductsQty,
        physicalSubscriptionQty: result.physicalSubscriptionQty,
        zuoraSubscriptionQty: result.physicalSubscriptionQty + (result.physicalProductsQty && 1),
        price: result.price,
    };
};
exports.default = getPhProductsQtyAndPrice;
//# sourceMappingURL=getPhProductsQtyAndPrice.js.map